import $ from "jquery";
import axios from 'axios';

var scrollpos = window.scrollY;

function setScrollPos() {
  scrollpos = window.scrollY;
}

function ajax_featured_post(term_id, slug) {

  let params = new URLSearchParams();
  params.append('action', 'featured_post_ajax');
  params.append('term_id', term_id);
  params.append('slug', slug);

  axios.post('/wp-admin/admin-ajax.php', params).then(res => {
    $('.featured-post').html(res.data.data.html);
    // window.scrollTo(0,scrollpos);
  });

}

function ajax_featured_posts(term_id, slug) {

  let params = new URLSearchParams();
  params.append('action', 'featured_posts_ajax');
  params.append('term_id', term_id);
  params.append('slug', slug);

  axios.post('/wp-admin/admin-ajax.php', params).then(res => {
    $('.featured-posts').html(res.data.data.html);
    if(res.data.data.more_pages == 1) {
      $('.section--archived-posts').css({'display': 'block'})
    } else {
      $('.section--archived-posts').css({'display': 'none'})
    }
  });

}

function ajax_archived_posts(term_id, slug) {

  let params = new URLSearchParams();
  params.append('action', 'archived_posts_ajax');
  params.append('term_id', term_id);
  params.append('slug', slug);

  axios.post('/wp-admin/admin-ajax.php', params).then(res => {
    $('.archived-posts').html(res.data.data.html);
    if(res.data.data.offset >= 21) {
      $('.archived-posts-more a').attr('data-offset', res.data.data.offset);
    } else {
      $('.archived-posts-more a').addClass('no-more-posts');
    }

    if(res.data.data.more_pages == 1) {
      $('.archived-posts-more a').removeClass('no-more-posts');
      $('.archived-posts-more a').removeClass('button--grey');
      $('.archived-posts-more a').addClass('button--blue');
    } else {
      $('.archived-posts-more a').addClass('no-more-posts');
      $('.archived-posts-more a').removeClass('button--blue');
      $('.archived-posts-more a').addClass('button--grey');
    }
  });

}

function ajax_more_archived_posts(term_id, slug, offset) {

  let params = new URLSearchParams();
  params.append('action', 'more_archived_posts_ajax');
  params.append('term_id', term_id);
  params.append('slug', slug);
  params.append('offset', offset);

  axios.post('/wp-admin/admin-ajax.php', params).then(res => {
    $('.archived-posts').append(res.data.data.html);
    $('.archived-posts-more a').attr('data-offset', res.data.data.offset);
    if(res.data.data.more_pages == 1) {
      $('.archived-posts-more a').removeClass('no-more-posts');
      $('.archived-posts-more a').removeClass('button--grey');
      $('.archived-posts-more a').addClass('button--blue');
    } else {
      $('.archived-posts-more a').addClass('no-more-posts');
      $('.archived-posts-more a').removeClass('button--blue');
      $('.archived-posts-more a').addClass('button--grey');
    }
    window.scrollTo(0,scrollpos);
  });

}

function setAttsOnLoadMore(term_id, slug) {
  $('.archived-posts-more a').attr('data-term-id', term_id);
  $('.archived-posts-more a').attr('data-slug', slug);
}

$('.posts-filters a').on('click', function() {
  var term_id = $(this).attr('data-term-id');
  var slug = $(this).attr('data-slug');
  $('.posts-filters a').removeClass('link--active');
  $(this).addClass('link--active');
  setScrollPos();
  setAttsOnLoadMore(term_id, slug);
  ajax_featured_post(term_id, slug);
  ajax_featured_posts(term_id, slug);
  ajax_archived_posts(term_id, slug);
});

$('.archived-posts-more a').on('click', function(e) {
  e.preventDefault();
  setScrollPos();
  var term_id = $(this).attr('data-term-id');
  var slug = $(this).attr('data-slug');
  var offset = $(this).attr('data-offset');
  if(!$(this).hasClass('no-more-posts')) {
    ajax_more_archived_posts(term_id, slug, offset);
  }
});

$('.posts-filters a[data-slug="all"]').click();